import React from 'react';
import Grid from '@mui/material/Grid';
import { StyledBox, StyledDescription, StyledTitle } from '../../styled';
import { IConfigOption } from '../../types';
import HelpVideoTile from './HelpVideoTile';

interface IHelpVideoTilesProps {
  configurationOptions?: IConfigOption;
}

const helpArticles = [
  {
    title: 'How to use the webcam tool',
    href: 'https://help.streamgo.live/article/73-tech-check-how-to-use-the-webcam-tool',
    always: true,
  },
  {
    title: 'Connection Troubleshooting',
    href: 'https://help.streamgo.live/article/124-firewall-whitelisting-for-presenters',
    always: true,
  },
  {
    title: 'How to use and control slides',
    href: 'https://help.streamgo.live/article/76-tech-check-how-to-use-and-control-slides',
    configKey: 'liveSlides',
  },
  {
    title: 'How does a pre-record to live work',
    href: 'https://help.streamgo.live/article/77-tech-check-how-does-a-pre-record-to-live-work',
    configKey: 'preRecord',
  },
  {
    title: 'Questions',
    href: 'https://help.streamgo.live/article/78-tech-check-how-to-use-the-questions-function',
    configKey: 'questions',
  },
  {
    title: 'How to use polls',
    href: 'https://help.streamgo.live/article/74-tech-check-how-to-use-polls',
    configKey: 'polls',
  },
  {
    title: 'How to use the screenshare tool',
    href: 'https://help.streamgo.live/article/75-tech-check-how-to-use-the-screenshare-tool',
    configKey: 'screenshare',
  },
];

export default function HelpVideoTiles({
  configurationOptions,
}: IHelpVideoTilesProps) {
  return (
    <StyledBox mt={3}>
      <StyledTitle variant="h2">Tech Check Articles</StyledTitle>
      <StyledDescription>
        Please see these tech check articles
      </StyledDescription>

      <Grid container={true} justifyContent={'center'} mt={3} spacing={2}>
        {helpArticles.map((article, index) => {
          if (
            article.always ||
            configurationOptions?.[article.configKey as keyof IConfigOption]
          ) {
            return (
              <Grid item={true} key={index} sm={4} xs={6}>
                <HelpVideoTile href={article.href} title={article.title} />
              </Grid>
            );
          }
          return null;
        })}
      </Grid>
    </StyledBox>
  );
}
